if (!customElements.get('nt-oil-starters')) {
  customElements.define('nt-oil-starters', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-offer-cream]').forEach(select => {
        select.addEventListener('change', () => this.chooseCream(select));
      });
      this.querySelectorAll('[data-offer-add]').forEach(button => {
        button.addEventListener('click', () => this.addBundle(button.closest('[data-offer-variant]'), button));
      });
      this.querySelectorAll('[data-offer-choice]').forEach(select => {
        select.addEventListener('change', () => {
          const card = select.closest('[data-offer-variant]');
          if (!card) return;
          card.querySelectorAll('[data-offer-choice]').forEach(other => { other.value = select.value; });
          card.querySelectorAll('[data-offer-color]').forEach(label => {
            label.textContent = select.selectedOptions[0]?.dataset.color || 'colore a scelta';
          });
        });
      });
      this.querySelectorAll('[data-starter-open]').forEach(button => {
        const dialog = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        if (!dialog) return;
        button.addEventListener('click', () => dialog.showModal());
        dialog.querySelectorAll('[data-starter-close]').forEach(close => {
          close.addEventListener('click', () => dialog.close());
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      this.initDots();
    }

    chooseCream(select) {
      const card = select.closest('[data-wellness-card]');
      if (!card || card.dataset.adding === 'true') return;
      let products;
      try { products = JSON.parse(card.querySelector('[data-offer-cream-products]').textContent); }
      catch { return; }
      const product = products.find(item => item.key === select.value);
      const expected = Number(card.dataset.offerPrice);
      const variants = product?.variants || [];
      card.dataset.offerProduct = product?.handle || '';
      card.dataset.offerVariant = String(variants.find(item => item.available && Number(item.price) === expected)?.id || '');
      card.querySelectorAll('[data-offer-cream]').forEach(other => { other.value = select.value; });
      card.querySelectorAll('[data-offer-cream-label]').forEach(label => { label.textContent = product?.label || 'scegli la tua formula'; });
      // A new cream is a different native bundle: reset the color and its variant IDs.
      card.querySelectorAll('[data-offer-choice]').forEach(other => {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = product ? 'Scegli il colore' : 'Scegli prima la crema viso';
        other.replaceChildren(placeholder);
        variants.forEach(variant => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.dataset.color = variant.title;
          option.disabled = !variant.available || Number(variant.price) !== expected;
          option.textContent = variant.title + (option.disabled ? ' - Non disponibile' : '');
          other.append(option);
        });
        other.value = '';
      });
      card.querySelectorAll('[data-offer-color]').forEach(label => { label.textContent = 'colore a scelta'; });
    }

    async addBundle(card, trigger) {
      if (!card || card.dataset.adding === 'true') return;
      const cream = trigger?.closest('dialog')?.querySelector('[data-offer-cream]') || card.querySelector('[data-offer-cream]');
      if (cream && !cream.reportValidity()) { cream.focus(); return; }
      const choice = trigger?.closest('dialog')?.querySelector('[data-offer-choice]') || card.querySelector('[data-offer-choice]');
      if (choice && !choice.reportValidity()) { choice.focus(); return; }
      const id = Number(choice ? choice.value : card.dataset.offerVariant);
      const expected = Number(card.dataset.offerPrice);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isFinite(expected) || expected <= 0) return;
      const buttons = [...card.querySelectorAll('[data-offer-add]')];
      const choices = [...card.querySelectorAll('[data-offer-choice], [data-offer-cream]')];
      const errors = [...card.querySelectorAll('[data-offer-error]')];
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const root = window.Shopify?.routes?.root || '/';
      card.dataset.adding = 'true';
      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      choices.forEach(select => { select.disabled = true; });
      errors.forEach(error => { error.hidden = true; error.textContent = ''; });
      let added = false;
      try {
        // Shopify remains the source of truth for bundle pricing and component stock.
        const productResponse = await fetch(`${root}products/${encodeURIComponent(card.dataset.offerProduct)}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!productResponse.ok) throw new Error('Questa selezione non \u00e8 disponibile. Ricarica la pagina.');
        const product = await productResponse.json();
        const variant = product.variants?.find(item => Number(item.id) === id);
        if (!variant?.available) throw new Error('Questa selezione \u00e8 esaurita.');
        if (Number(variant.price) !== expected) throw new Error('Il prezzo della selezione \u00e8 cambiato. Ricarica la pagina prima di acquistare.');
        const body = { items: [{ id, quantity: 1 }] };
        if (cart) {
          body.sections = cart.getSectionsToRender().map(section => section.id);
          body.sections_url = location.pathname;
          cart.setActiveElement?.(buttons[0]);
        }
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Non \u00e8 stato possibile aggiungere la selezione.');
        added = true;
        card.querySelector('dialog[open]')?.close();
        if (cart && state.sections && Object.values(state.sections).every(value => value !== null)) {
          cart.classList.remove('is-empty');
          cart.renderContents(state);
        } else location.assign(window.routes?.cart_url || `${root}cart`);
      } catch (error) {
        if (added) {
          location.assign(window.routes?.cart_url || `${root}cart`);
          return;
        }
        errors.forEach(element => { element.textContent = error.message || 'Non \u00e8 stato possibile aggiungere la selezione. Riprova.'; element.hidden = false; });
      } finally {
        card.dataset.adding = 'false';
        buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
        choices.forEach(select => { select.disabled = false; });
      }
    }

    // Su telefono le offerte scorrono in orizzontale: i puntini mostrano la posizione.
    initDots() {
      const track = this.querySelector('[data-starters-track].nt-ol-starters__grid--carousel');
      const dots = this.querySelector('[data-starters-dots]');
      if (!track || !dots || track.children.length < 2) return;
      const cards = [...track.children];
      dots.innerHTML = cards.map(() => '<i></i>').join('');
      const mark = () => {
        const origin = track.getBoundingClientRect().left;
        let active = 0;
        cards.forEach((card, index) => {
          if (Math.abs(card.getBoundingClientRect().left - origin) < Math.abs(cards[active].getBoundingClientRect().left - origin)) active = index;
        });
        [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(mark), { passive: true });
      mark();
    }
  });
}
